import type { GetEventFieldValuesResponse } from '@vy/api-definition';
import { GetEventFieldValuesResponseSchema } from '@vy/api-definition';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';
import { queryKeys } from '../../services/query-key/query-keys';

export function useEventFieldValues(
  eventName: string,
  fieldName: string,
  options?: CustomUseQueryOptions<GetEventFieldValuesResponse>,
) {
  return useQuery(
    queryKeys.eventFieldValues(eventName, fieldName),
    async () => {
      const privateApi = getPrivateApi();
      const getEventFieldValuesResponse = await privateApi.getEventFieldValues({
        eventName,
        fieldName,
      });

      return GetEventFieldValuesResponseSchema.parse(getEventFieldValuesResponse);
    },
    options,
  );
}
